//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
let d=[[[0,"Length",0,0]],[[[],"CreateGeometricConstraintData",{R_:{data:"Features.GeometricConstraintData"}},0,0],[["constraint"],"Append",{},1,0],[["insert_before_index","constraint"],"Insert",{},2,0],[["constraint"],"Delete",{},1,0],[["constraint_index"],"Delete1",{},1,0],[[],"Clear",{},0,0],[["number_of_constraints"],"GetContents",{R_:{constraints:"Features.GeometricConstraintData[]"}},0,0],[["constraints"],"SetContents",{},1,0],[["constraint_index"],"FindItem",{R_:{constraint:"Features.GeometricConstraintData"}},1,0],[["constraint"],"GetIndex",{R_:{constraint_index:''}},1,0]],[]];
SPLM.Features.GeometricConstraintDataManager = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.GeometricConstraintDataManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;